import moment from 'moment';

export const createFlexibleDeliveryTimeWindows = (selectedTimeSlot) =>
{
  const militaryTime = selectedTimeSlot.times.map(x => moment(x.time, ["h:mm A"]).format('HH:mm'));

  const indexInFirstWindow = militaryTime.findIndex(x => x === militaryTime.find(t => t < "10:59"));
  const indexInSecondWindow = militaryTime.findIndex(x => x === militaryTime.find(t => (t >= "11:00" && t < "13:59")));
  const indexInThirdWindow = militaryTime.findIndex(x => x === militaryTime.find(t => (t >= "14:00" && t < "16:59")));
  const indexInFourthWindow = militaryTime.findIndex(x => x === militaryTime.find(t => t >= "17:00"));

  const flexibleDeliveryWindows = [indexInFirstWindow, indexInSecondWindow, indexInThirdWindow, indexInFourthWindow];

  return flexibleDeliveryWindows;
}

export const getFlexibleDeliveryButtonLabels = (index) => {

  const timeWindows = ["8 AM - 11 AM", "11 AM - 2 PM", "2 PM - 5 PM", "5 PM - 8 PM"];
  return timeWindows[index];
}

export const displayFlexibleDeliveryWindow = (selectedTimeSlot) => {

  const militaryTime = moment(selectedTimeSlot, ["h:mm A"]).format('HH:mm');

  switch(true)
  {
    case (militaryTime < "10:59"):
      return "8am - 11am";
    case (militaryTime >= "11:00" && militaryTime < "13:59"):
      return "11am - 2pm";
    case (militaryTime >= "14:00" && militaryTime < "16:59"):
      return "2pm - 5pm";
    default:
      return  "5pm - 8pm";
  }
}
